<template>
  <div>
    <div class="here-map">
      <div ref="map" v-bind:style="{ width: width, height: height }"></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "mapa",
  data() {
    return {
      map: {}
      //  platform: {}
    }
  },
  props: {
    lat: String,
    lng: String,
    width: String,
    height: String,
    platformHere: null
  },
  created() {},
  mounted() {
    this.initHereMap()
  },
  methods: {
    initHereMap() {
      try {
        this.map = new H.Map(this.$refs.map, this.platformHere.createDefaultLayers().normal.map, {
          zoom: 14,
          center: {
            lng: this.lng.replace(",", "."),
            lat: this.lat.replace(",", ".")
          }
        })
        var berlinMarker = new H.map.Marker({
          lat: this.lat.replace(",", "."),
          lng: this.lng.replace(",", ".")
        })
        // berlinMarker.draggable = true;
        this.map.addObject(berlinMarker)
        var behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map))
        var ui = H.ui.UI.createDefault(this.map, this.platformHere.createDefaultLayers())
        this.addDraggableMarker(this.map, behavior)
      } catch (e) {
        console.log(e)
      }
    },
    addDraggableMarker(map, behavior) {
      // disable the default draggability of the underlying map
      // when starting to drag a marker object:
      map.addEventListener(
        "dragstart",
        function(ev) {
          var target = ev.target
          if (target instanceof H.map.Marker) {
            behavior.disable()
          }
        },
        false
      )

      // re-enable the default draggability of the underlying map
      // when dragging has completed
      map.addEventListener(
        "dragend",
        function(ev) {
          var target = ev.target
          if (target instanceof mapsjs.map.Marker) {
            behavior.enable()
          }
        },
        false
      )

      // Listen to the drag event and move the position of the marker
      // as necessary
      map.addEventListener(
        "drag",
        function(ev) {
          var target = ev.target,
            pointer = ev.currentPointer
          if (target instanceof mapsjs.map.Marker) {
            target.setPosition(map.screenToGeo(pointer.viewportX, pointer.viewportY))
          }
        },
        false
      )
    }
  }
}
</script>
